class AccordionGroup extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelectorAll("details");
    this.details.forEach((detail) => {
      const summary = detail.querySelector("summary");
      const content = detail.querySelector(".accordion-content");
      if (detail.open && content) {
        content.style.maxHeight = content.scrollHeight + "px";
        this.toggleIcon(detail, true);
      }
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        if (detail.hasAttribute("open")) {
          this.close(detail);
        } else {
          this.closeAll();
          this.open(detail);
        }
      });
    });
  }
  open(detail) {
    const content = detail.querySelector(".accordion-content");
    detail.setAttribute("open", "");
    this.toggleIcon(detail, true);
    requestAnimationFrame(() => {
      if (content) content.style.maxHeight = content.scrollHeight + "px";
    });
  }
  close(detail) {
    const content = detail.querySelector(".accordion-content");
    if (content) content.style.maxHeight = "0";
    this.toggleIcon(detail, false);
    setTimeout(() => {
      detail.removeAttribute("open");
    }, 300);
  }
  toggleIcon(detail, isOpen) {
    const plus = detail.querySelector(".accordion-icon-plus");
    const minus = detail.querySelector(".accordion-icon-minus");
    if (plus) {
      plus.style.opacity = isOpen ? "0" : "1";
      plus.style.transform = isOpen ? "rotate(90deg)" : "rotate(0deg)";
    }
    if (minus) {
      minus.style.opacity = isOpen ? "1" : "0";
      minus.style.transform = isOpen ? "rotate(0deg)" : "rotate(-90deg)";
    }
  }
  closeAll() {
    this.details.forEach((detail) => {
      if (detail.hasAttribute("open")) this.close(detail);
    });
  }
}
customElements.define("accordion-group", AccordionGroup);
